export const GOOGLE_CAPTCHA_PARAM_KEY_V2 = 'g_recaptcha_response_2';
export const GOOGLE_CAPTCHA_PARAM_KEY_V3 = 'g_recaptcha_response';
